const doc = [({"en":({"js":({"admin":({"photo_types":({"create_card":({"create_photo_type":"Create photo type"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;